window.addEventListener('load', function () {
  const searchForms = document.querySelectorAll('[data-search_form]');
  searchForms.forEach(initSearchForm);
});

function initSearchForm(searchForm) {
  const queryInput = searchForm.querySelector('input[name="q"]');
  searchForm.addEventListener('submit', function (event) {
    if (!queryInput.value) return event.preventDefault();
    // preserve product filters search params
    const productFilters = document.querySelectorAll('[data-filter]');
    if (!productFilters.length) return;
    appendFilterInputs(this, productFilters);
  });
  // predictive search suggestions
  const predictiveSearchContainer = searchForm.querySelector('[data-predictive_search]');
  if (!predictiveSearchContainer) return;
  let debounceTimeout;
  queryInput.addEventListener('input', function (event) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      getPredictiveSearchSuggestions(predictiveSearchContainer, queryInput.value.trim());
    }, 500);
  });
  queryInput.addEventListener('focus', (event) => {
    predictiveSearchContainer.classList.remove('hidden');
  });
  queryInput.addEventListener('blur', (event) => {
    setTimeout(() => {
      predictiveSearchContainer.classList.add('hidden');
    }, 300);
  });
}

function appendFilterInputs(form, filters) {
  filters.forEach((filter) => {
    if (!filter.dataset.hasOwnProperty('param')) return;
    const activeValues = filter.querySelectorAll('[data-active]');
    if (!activeValues.length) return;
    activeValues.forEach((filterValue) => {
      if (!filterValue.dataset.hasOwnProperty('value')) return;
      const filterInput = getFilterInputElement(filter.dataset.param, filterValue.dataset.value);
      form.appendChild(filterInput);
    });
  });
}

function getFilterInputElement(name, value) {
  const input = document.createElement('input');
  input.setAttribute('type', 'hidden');
  input.name = name;
  input.value = value;

  return input;
}

async function getPredictiveSearchSuggestions(container, query) {
  container.innerHTML = '';
  if (!query) return;
  const url = `${container.dataset.predictive_search}?q=${query}&resources[type]=${container.dataset.resources}&resources[options][unavailable_products]=hide&section_id=predictive-search`;
  const promise = await attemptFetch('fetching predictive search suggestions', url);
  if (!promise) return false;
  const html = await promise.text();
  if (!html) return false;
  // append fetched search results to predictive search container
  const temp = document.createElement('div');
  temp.innerHTML = html;
  const wrapper = temp.querySelector('[data-predictive_search_results]');
  const results = wrapper.querySelectorAll('[data-predictive_search_group]');
  results.forEach((result) => {
    container.appendChild(result);
  });
}
